import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    CI_COMMIT_SHA: z.string().optional().default(''),
    ACTUAL_ENV: z.string().optional().default(''),
    REVALIDATE_SECRET: z.string().min(1, 'REVALIDATE_SECRET is required — revalidation endpoint is unsecured without it'),
    GOOGLE_RECAPTCHA_SECRET_KEY: z.string().min(1, 'GOOGLE_RECAPTCHA_SECRET_KEY is required — product registration will reject all submissions'),
  },
  client: {
    NEXT_PUBLIC_AUTH_API_URL: z.string().optional().default('https://auth-api.iot.traegergrills.io'),
    NEXT_PUBLIC_BV_ENVIRONMENT: z.string().optional().default('production'),
    NEXT_PUBLIC_GTM_ID: z.string().optional().default(''),
    NEXT_PUBLIC_DATAGRAIL_CUSTOMER_ID: z.string().optional().default(''),
    NEXT_PUBLIC_DATAGRAIL_CONTAINER_ID: z.string().optional().default(''),
    NEXT_PUBLIC_WEB_ENV: z.string().optional().default('https://www.traeger.com'),
    NEXT_PUBLIC_LOCALLY_COMPANY_ID: z.coerce.number().optional().default(112256),
    NEXT_PUBLIC_LOCALLY_COMPANY_NAME: z.string().optional().default('Traeger%20Grill'),
    NEXT_PUBLIC_LOCALLY_DOMAIN: z.string().optional().default('traeger-grill.locally.com'),
    NEXT_PUBLIC_COMMERCE_PROVIDER: z.string().optional().default('shopify'),
    NEXT_PUBLIC_SENTRY_DSN: z.string().optional().default(''),
    NEXT_PUBLIC_SENTRY_ENV: z.string().optional().default(''),
    NEXT_PUBLIC_USE_SENTRY: z.string().optional().default(''),
    NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY: z.string().min(1, 'NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY is required — product registration form will crash'),
    NEXT_PUBLIC_LOAD_MARKETING_SCRIPTS: z.string().optional().default(''),
    NEXT_PUBLIC_APP_ENV: z.string().optional().default(''),
    NEXT_PUBLIC_GRAPHQL_API_URL: z.string().optional().default(''),
    NEXT_PUBLIC_GREENHOUSE_DEPTS_URL: z.string().optional().default(''),
    NEXT_PUBLIC_API_MOCKING: z.string().optional().default(''),
    NEXT_PUBLIC_SHOPIFY_CHECKOUT_URL: z.string().url('NEXT_PUBLIC_SHOPIFY_CHECKOUT_URL must be a valid URL — checkout will crash'),
    NEXT_PUBLIC_INVALID_DELIVERY_KEYS: z
      .string()
      .optional()
      .default('')
      .transform((val) => (val ? val.split(',') : [])),
    NEXT_PUBLIC_REVALIDATE_PAGE_TIME: z.coerce.number().default(14400),
    NEXT_PUBLIC_REVALIDATE_LAYOUT_TIME: z.coerce.number().default(86400),
    NEXT_PUBLIC_REVALIDATE_SEARCH_TIME: z.coerce.number().default(300),
  },
  runtimeEnv: {
    // Server
    CI_COMMIT_SHA: process.env.CI_COMMIT_SHA,
    ACTUAL_ENV: process.env.ACTUAL_ENV,
    REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,
    GOOGLE_RECAPTCHA_SECRET_KEY: process.env.GOOGLE_RECAPTCHA_SECRET_KEY,
    // Client
    NEXT_PUBLIC_AUTH_API_URL: process.env.NEXT_PUBLIC_AUTH_API_URL,
    NEXT_PUBLIC_BV_ENVIRONMENT: process.env.NEXT_PUBLIC_BV_ENVIRONMENT,
    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    NEXT_PUBLIC_DATAGRAIL_CUSTOMER_ID: process.env.NEXT_PUBLIC_DATAGRAIL_CUSTOMER_ID,
    NEXT_PUBLIC_DATAGRAIL_CONTAINER_ID: process.env.NEXT_PUBLIC_DATAGRAIL_CONTAINER_ID,
    NEXT_PUBLIC_WEB_ENV: process.env.NEXT_PUBLIC_WEB_ENV,
    NEXT_PUBLIC_LOCALLY_COMPANY_ID: process.env.NEXT_PUBLIC_LOCALLY_COMPANY_ID,
    NEXT_PUBLIC_LOCALLY_COMPANY_NAME: process.env.NEXT_PUBLIC_LOCALLY_COMPANY_NAME,
    NEXT_PUBLIC_LOCALLY_DOMAIN: process.env.NEXT_PUBLIC_LOCALLY_DOMAIN,
    NEXT_PUBLIC_COMMERCE_PROVIDER: process.env.NEXT_PUBLIC_COMMERCE_PROVIDER,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_SENTRY_ENV: process.env.NEXT_PUBLIC_SENTRY_ENV,
    NEXT_PUBLIC_USE_SENTRY: process.env.NEXT_PUBLIC_USE_SENTRY,
    NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
    NEXT_PUBLIC_LOAD_MARKETING_SCRIPTS: process.env.NEXT_PUBLIC_LOAD_MARKETING_SCRIPTS,
    NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_GRAPHQL_API_URL: process.env.NEXT_PUBLIC_GRAPHQL_API_URL,
    NEXT_PUBLIC_GREENHOUSE_DEPTS_URL: process.env.NEXT_PUBLIC_GREENHOUSE_DEPTS_URL,
    NEXT_PUBLIC_API_MOCKING: process.env.NEXT_PUBLIC_API_MOCKING,
    NEXT_PUBLIC_SHOPIFY_CHECKOUT_URL: process.env.NEXT_PUBLIC_SHOPIFY_CHECKOUT_URL,
    NEXT_PUBLIC_INVALID_DELIVERY_KEYS: process.env.NEXT_PUBLIC_INVALID_DELIVERY_KEYS,
    NEXT_PUBLIC_REVALIDATE_PAGE_TIME: process.env.NEXT_PUBLIC_REVALIDATE_PAGE_TIME,
    NEXT_PUBLIC_REVALIDATE_LAYOUT_TIME: process.env.NEXT_PUBLIC_REVALIDATE_LAYOUT_TIME,
    NEXT_PUBLIC_REVALIDATE_SEARCH_TIME: process.env.NEXT_PUBLIC_REVALIDATE_SEARCH_TIME,
  },
  // Skip validation in test mode so unit tests aren't blockedkip validation in test/Storybook so unit tests and stories aren't blocked by missing env vars
  skipValidation: process.env.NODE_ENV === 'test' || !!process.env.STORYBOOK,
  onValidationError: (error) => {
    console.error('Invalid environment variables:', JSON.stringify(error, null, 2));
    throw new Error('Invalid environment variables');
  },
});
